import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import MainLogo from "assets/images/icons/logo-qw-light.png";
import MainLogoDark from "assets/images/icons/logo-dark.png";
// import CartLogo from 'assets/images/icons/cart.svg'
import { Link } from "react-router-dom";
import { Navbar, Container, Button, Spinner } from "react-bootstrap";
import ModalRegisterSimple from "layouts/ModalRegisterSimple";
import ModalLogin from "layouts/ModalLogin";
import { useTheme } from "contexts/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun, faMoon } from "@fortawesome/free-solid-svg-icons";
import "./style.css";

const NavbarComponent = () => {
  const [showLogin, setModalLogin] = useState(false);
  const [showDaftar, setModalDaftar] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 1200,
    height: typeof window !== 'undefined' ? window.innerHeight : 800
  });
  const isLogin = useSelector((state) => state.auth.status_login);
  const isLoading = useSelector((state) => state.auth.status);
  const redirectUrl = useSelector((state) => state.auth.redirectUrl);
  const userData = useSelector((state) => state.auth.data_login?.client);
  const [isLogoutLoading, setIsLogoutLoading] = useState(false);
  const { isDarkMode, toggleTheme } = useTheme();

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Selamat Pagi,";
    if (hour < 15) return "Selamat Siang,";
    if (hour < 19) return "Selamat Sore,";
    return "Selamat Malam,";
  };

  const getUserName = () => {
    if (!userData) return "";
    const firstName = userData.firstname || "";
    const lastName = userData.lastname || "";
    return `${firstName} ${lastName}`.trim();
  };

  const handlerLogout = async (e) => {
    e.preventDefault();
    setIsLogoutLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API}logout.php`, {
        method: "GET",
        credentials: "include",
      });
      await response.text();
      window.location.reload();
    } catch (err) {
      console.error("Logout error:", err);
      window.location.reload();
    } finally {
      setIsLogoutLoading(false);
    }
  };

  useEffect(() => {
    if (isLoading === "idle" && redirectUrl) {
      window.location.href = redirectUrl;
    }
  }, [isLoading, redirectUrl]);

  // Handle window resize for responsive layout
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Navbar 
      bg={isDarkMode ? "dark" : "white"}
      expand="lg" 
      className="sticky-top shadow-sm navbar-checkout" 
      id="navCheckout"
      expanded={expanded}
      onToggle={(expanded) => setExpanded(expanded)}
    >
      <Container 
        fluid 
        className="px-3 px-lg-4 navbar-container"
      >
        <Navbar.Toggle 
          aria-controls="navbarTogglerDemo01" 
          className="border-0 p-2 navbar-toggle"
        />
        
        <Navbar.Brand 
          as={Link} 
          to="/" 
          className="me-3 d-flex align-items-center navbar-brand"
        >
          <img 
            src={isDarkMode ? MainLogoDark : MainLogo} 
            alt="Qwords Logo" 
            width="140px" 
          />
        </Navbar.Brand>

        <Navbar.Collapse id="navbarTogglerDemo01" className="ms-auto justify-content-end">
          {/* Dark Mode Toggle Button */}
          <Button
            className="navbar-btn-dark-mode me-2 me-lg-3"
            onClick={toggleTheme}
            variant="outline-secondary"
            aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
            title={isDarkMode ? "Mode Terang" : "Mode Gelap"}
          >
            <FontAwesomeIcon 
              icon={isDarkMode ? faSun : faMoon} 
              style={{ fontSize: '18px' }}
            />
          </Button>

          {isLogin ? (
            <div className="d-flex align-items-center gap-2 gap-lg-3 flex-wrap justify-content-end" style={{ width: '100%' }}>
              {/* User Info - Responsive */}
              <div className="d-flex flex-column user-info-container">
                {/* Desktop version */}
                <small className="text-muted d-none d-sm-block text-end user-info-desktop">
                  {getGreeting()}
                </small>
                <span className="fw-bold d-none d-sm-block text-end user-name-desktop">
                  {getUserName()}
                </span>
                
                {/* Mobile version - centered and clear */}
                <div className="d-sm-none text-center">
                  <div className="text-muted user-info-mobile">
                    {getGreeting()}
                  </div>
                  <div className="fw-bold user-name-mobile">
                    {getUserName()}
                  </div>
                </div>
              </div>
              
              {/* Separator - Only show on desktop and when window is large enough */}
              {windowSize.width >= 992 && (
                <div className="vr navbar-separator" style={{ height: '30px' }}></div>
              )}
              
              {/* Logout Button */}
              <Button 
                className="navbar-btn navbar-btn-logout"
                onClick={handlerLogout}
                disabled={isLogoutLoading}
              >
                {isLogoutLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="navbar-spinner"
                      variant="danger"
                    />
                    <span>Keluar</span>
                  </>
                ) : (
                  <span>Keluar</span>
                )}
              </Button>
            </div>
          ) : (
            <div className="navbar-btn-container">
              {/* Register Button */}
              <Button
                className="navbar-btn navbar-btn-outline"
                onClick={() => {
                  setModalDaftar(true);
                  setExpanded(false);
                }}
              >
                Daftar
              </Button>

              {/* Login Button */}
              <Button
                className="navbar-btn navbar-btn-solid"
                onClick={() => {
                  setModalLogin(true);
                  setExpanded(false);
                }}
              >
                Masuk
              </Button>
            </div>
          )}
        </Navbar.Collapse>

        <ModalRegisterSimple
          show={showDaftar}
          onHide={() => setModalDaftar(false)}
          onClickDaftar={setModalDaftar}
          onClickLogin={setModalLogin}
        />

        <ModalLogin
          show={showLogin}
          onHide={() => setModalLogin(false)}
          onClickDaftar={setModalDaftar}
          onClickLogin={setModalLogin}
        />
      </Container>
    </Navbar>
  );
};

export default NavbarComponent;